import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Typography,
    ListItem,
    ListItemButton,
    ListItemText,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import theme from "../../../components/LayoutComponents/theme";
import {
    updateTemplate, requestTemplates, createTemplate, deleteTemplate,
    getTemplateSkills, saveTemplateSkills, updateTemplateSkills
} from "../../../remote/templatesRequest";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import TemplateForm from "./TemplateForm";
import { } from "../../../remote/templatesRequest";


export default function Templates({ session, competencies, proficiencies }) {
    const [selected, setSelected] = useState(null);
    const [templates, setTemplates] = useState([]);
    const [templateTypes, setTemplateTypes] = useState([]);
    const [selectedTemplateType, setSelectedTemplateType] = useState("");
    const [skills, setSkills] = useState(null);
    const initialFormData = {
        templateId: 0,
        templateName: "",
        templateDescription: "",
        activeFlag: false,
        templateInternal: false,
        templateType: "",
        degreeTypeId: null,
        sectorId: null,
        industryId: null,
        occupationFamilyTitlesId: null,
        militaryCategoryId: null,
        username:session?.username + ' - ' + session?.name 
    };
    const [formData, setFormData] = useState(initialFormData)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!session?.token) return;
        const loadSkills = async () => {
            if (selected?.templateId) {
                try {
                    setLoading(true)
                    const response = await getTemplateSkills(session?.token, selected?.templateId);
                    setSkills(response.data || []);
                } catch (error) {
                    console.error("Error fetching template skills:", error);
                } finally {
                    setLoading(false)
                }
            } else {
                setSkills([]);
            }
        };

        if (session?.token && selected?.templateId !== 0) {
            loadSkills();
        }
    }, [session?.token, selected?.templateId]);

    useEffect(() => {
        if (!session?.token) return;
        const fetchTemplates = async () => {
            try {
                const response = await requestTemplates(session.token);
                const uniqueTemplateTypes = [
                    ...new Set(
                        response.data
                            .filter(t => t.templateType && t.templateType !== "")
                            .map(t => t.templateType)
                    )
                ];
                setTemplates(response.data);
                setTemplateTypes(uniqueTemplateTypes);
            } catch (error) {
                console.error("Error fetching templates:", error);
            }
        };

        fetchTemplates();
    }, [session?.token]);

    const handleSave = async () => {
        let resTemp;
        let resSkills;
        try {
            setLoading(true)
            if (formData?.templateId === 0) {
                resTemp = await createTemplate(session?.token, formData);
                resSkills = await saveTemplateSkills(session?.token, resTemp?.data?.templateId, skills);
                setTemplates((prev) => [resTemp.data, ...prev]);
                setSkills(resSkills.data);
            } else {
                await updateTemplate(session?.token, formData);
                await updateTemplateSkills(session?.token, formData.templateId, skills);
                let res = await requestTemplates(session.token)
                setTemplates(res.data || [])
            }
        } catch (err) {
            console.error("Error saving template", err);
        } finally {
            setLoading(false)
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true)
            let res = await deleteTemplate(session?.token, selected?.templateId)
            setTemplates(res.data);
            setSelected(null);
            setFormData(initialFormData);
            alert("Template Deteleted Successfuly.")
        } catch (err) {
            console.error("Error deleting template", err);
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box sx={{ display: "flex", gap: 3, width: "100%", alignItems: "flex-start" }}>
            <Paper
                sx={{
                    width: "25%",
                    p: 2,
                    height: "60vh",
                    overflowY: "auto",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ mb: 2, color: theme.colors.purple, textAlign: "center" }}
                >
                    Templates
                </Typography>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Filter by Type</InputLabel>
                    <Select
                        value={selectedTemplateType}
                        label="Filter by Type"
                        onChange={(e) => setSelectedTemplateType(e.target.value)}
                    >
                        <MenuItem value="">All</MenuItem>
                        {templateTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {templates?.length > 0 || !loading ?
                    templates
                        ?.filter(t => !selectedTemplateType || t.templateType === selectedTemplateType)
                        ?.sort((a, b) => a.templateName.toLowerCase().localeCompare(b.templateName.toLowerCase()))
                        .map((tpl) => (
                            <ListItem key={tpl.templateId} disablePadding>
                                <ListItemButton
                                    selected={selected?.templateId === tpl.templateId}
                                    onClick={() => {
                                        setSelected(tpl);
                                        setFormData(tpl);
                                    }}
                                >
                                    <ListItemText primary={tpl?.templateName} />
                                </ListItemButton>
                            </ListItem>
                        ))
                    :  <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                bgcolor: "rgba(255,255,255,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2000,
              }}
            >
              <LoadingCircle />
            </Box>
                }
            </Paper>
            <Box sx={{ flex: 1, minWidth: 600 }}>
                <TemplateForm
                    onSave={handleSave}
                    onDelete={handleDelete}
                    session={session}
                    competencies={competencies}
                    proficiencies={proficiencies}
                    templateTypes={templateTypes}
                    skills={skills}
                    setSkills={setSkills}
                    formData={formData}
                    setFormData={setFormData}
                    loading={loading}
                />
            </Box>
        </Box>
    );
}

